const SHIPROCKET_ADMIN_PATH = "/api/shiprocket/admin";

export async function shiprocketAdminRequest({ username, password, action, order, parcel, awb, shipmentId, shiprocketOrderId }) {
  try {
    const res = await fetch(SHIPROCKET_ADMIN_PATH, {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      body: JSON.stringify({
        adminUsername: username,
        adminPassword: password,
        action,
        order,
        parcel,
        awb,
        shipmentId,
        shiprocketOrderId,
      }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || data?.ok === false) {
      return { ok: false, message: data?.message || `Shiprocket request failed (${res.status})`, data };
    }
    return { ok: true, data };
  } catch (err) {
    return { ok: false, message: err?.message || "Network error while calling Shiprocket." };
  }
}
